export function nodeDetailPath(nodeId: string): string {
  return `/nodes/${encodeURIComponent(nodeId)}`
}

export function guardianAlphaConfigPath(
  nodeId: string,
  guardianNodeId?: string,
  tab?: 'settings' | 'config' | 'input',
): string {
  const query = new URLSearchParams({ node: nodeId })
  if (guardianNodeId) query.set('guardianNode', guardianNodeId)
  if (tab && tab !== 'settings') query.set('tab', tab)
  return `/guardian-alpha/config?${query.toString()}`
}

export function manualOperatingTargetPath(targetId: string): string {
  return `/guardian-alpha/manual-operating/${encodeURIComponent(targetId)}`
}

export function guardianAlphaRestartResultPath(nodeId: string): string {
  return `/nodes/${encodeURIComponent(nodeId)}/guardian-alpha/restart-result`
}
